/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Error_FieldInputs */

const en_us2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check this answer.`)
};

const pt_br2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira esta resposta.`)
};

const es_419_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa esta respuesta.`)
};

const pt_pt2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica esta resposta.`)
};

const fr_fr2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie cette réponse.`)
};

const de_de2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüf diese Antwort.`)
};

const it_it2_profile_editors_error_field = /** @type {(inputs: Profile_Editors_Error_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla questa risposta.`)
};

/**
* | output |
* | --- |
* | "Check this answer." |
*
* @param {Profile_Editors_Error_FieldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_error_field = /** @type {((inputs?: Profile_Editors_Error_FieldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Error_FieldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_error_field(inputs)
	if (locale === "es-419") return es_419_profile_editors_error_field(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_error_field(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_error_field(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_error_field(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_error_field(inputs)
	return en_us2_profile_editors_error_field(inputs)
});
export { profile_editors_error_field as "profile-editors.error_field" }